import { useEffect, useRef } from 'react';

export const useMount = <T extends () => void | Promise<void>>(fn: T) => {
    const fnRef = useRef(fn);

    useEffect(() => {
        void fnRef.current();
    }, []);
};
